import _ from 'lodash';

// Filter/Sort/Query Handlers
export const handleQuery = (
  query,
  setQuery,
  parentKey,
  updateKey,
  value,
  defaultQuery = null,
) => {
  // Reset logic
  if (parentKey === 'reset') {
    setQuery(defaultQuery || {});
    return;
  }

  const prevQuery = { ...query };

  if (parentKey && !updateKey) {
    prevQuery[parentKey] = value;
  } else {
    prevQuery[parentKey][updateKey] = value;
  }

  setQuery(prevQuery);
};

export const handleFilter = (
  query,
  setQuery,
  filterKey,
  filterValue,
  filterPredicate,
  seperateValues = false,
  reset = false,
) => {
  const prevQuery = { ...query };

  if (reset) {
    delete prevQuery.filters;
    setQuery(prevQuery);
    return;
  }

  if (!prevQuery.filters && filterValue) {
    prevQuery.filters = [];
  }

  const filterIndex = _.findIndex(prevQuery.filters, ['name', filterKey]);

  if (!filterValue && prevQuery.filters) {
    delete prevQuery.filters[filterIndex];
  } else if (filterValue && !seperateValues) {
    const newFilter = {
      name: filterKey,
      value: filterValue,
      predicate: filterPredicate,
    };

    if (filterIndex !== -1) {
      prevQuery.filters[filterIndex] = { ...newFilter };
    } else {
      prevQuery.filters.push(newFilter);
    }
  } else if (filterValue && seperateValues) {
    // Remove ALL existing filters with this name first (for date ranges)
    if (prevQuery.filters) {
      prevQuery.filters = prevQuery.filters.filter((filter) => filter.name !== filterKey);
    }
    // Then add the new filters
    const addFilters = prevQuery.filters.concat(filterValue);
    prevQuery.filters = addFilters;
  }

  if (prevQuery.filters && prevQuery.filters.length === 0) {
    delete prevQuery.filters;
  }

  if (prevQuery.paging && prevQuery.paging.to) {
    prevQuery.paging.to = 1;
  }

  setQuery(prevQuery);
};

export const handleSort = (
  query,
  setQuery,
  sortValue,
  sortDirection,
) => {
  const prevQuery = { ...query };

  if (!prevQuery.sort && sortValue) {
    prevQuery.sort = {};
  }

  if (sortValue === null && prevQuery.sort) {
    delete prevQuery.sort;
  } else if (sortValue) {
    prevQuery.sort = {
      name: sortValue,
      direction: sortDirection,
    };
  }

  setQuery(prevQuery);
};

// Review Handlers
/* eslint-disable camelcase */
export const initializeReviewedRows = (
  setReviewedData,
  data,
  setInitialLaterCount = null,
) => {
  const reviewDataArr = data.map((dt) => {
    // Support both old flat-array rows and new {id, cells} format
    const cells = Array.isArray(dt) ? dt : (dt.cells || dt);
    const reviewable = _.find(cells, ((row) => row.decoration === 'editable/dropdown'));
    const id = reviewable?.editableId;
    const api = reviewable?.api;

    return { id, review_status: api, prev_status: api };
  });

  const filteredReviewable = _.filter(reviewDataArr, ((dt) => dt.id !== undefined));
  if (setInitialLaterCount) {
    const laterCount = filteredReviewable && _.filter(filteredReviewable, (({ review_status }) => review_status === 'later')).length;
    setInitialLaterCount(laterCount);
  }

  setReviewedData(filteredReviewable);
};

export const updateRowReviewStatus = (
  reviewedData,
  setReviewedData,
  editableId,
  selectedOption,
) => {
  const reviewDataArr = [...reviewedData];
  const editSelectionIndex = _.findIndex(reviewDataArr, { id: editableId });

  if (editSelectionIndex !== -1) {
    reviewDataArr[editSelectionIndex].review_status = selectedOption;
    setReviewedData(reviewDataArr);
  }
};

export const updateMultipleRowsReviewStatus = (
  reviewedData,
  setReviewedData,
  editableIds,
  selectedOption,
) => {
  const reviewDataArr = [...reviewedData];

  editableIds.forEach((editableId) => {
    const editSelectionIndex = _.findIndex(reviewDataArr, { id: editableId });

    if (editSelectionIndex !== -1) {
      reviewDataArr[editSelectionIndex].review_status = selectedOption;
    }
  });

  setReviewedData(reviewDataArr);
};
/* eslint-enable camelcase */
